var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"container",staticClass:"marquee-text-container",style:(_vm.containerStyle)},[_c('div',{ref:"message",staticClass:"sitemessage",style:(_vm.animationStyle)},[_vm._v(" "+_vm._s(_vm.text)+" ")])])}
var staticRenderFns = []

export { render, staticRenderFns }